import { Modal } from "antd";
import React from "react";
import DeleteIcon from "./../../../graphics/svgs/DeleteIcon.svg";

const { confirm } = Modal;

const DeleteFormulaItem: React.FC<IDeleteFormulaItemProps> = ({
  _id,
  deleteFormula,
}) => {
  const handleDeleteConfirmation = () => {
    confirm({
      title: `Are you sure you want to delete formula?`,
      content: `This action will delete the formula.`,
      onOk() {
        const values = {
          _id: _id,
        };
        deleteFormula(values);
      },
      onCancel() {},
    });
  };

  return (
    <>
      <img
        src={DeleteIcon}
        onClick={handleDeleteConfirmation}
        style={{ width: "25px", cursor: "pointer" }}
      />
    </>
  );
};
export default DeleteFormulaItem;
